import { useEffect, useState } from "react";
import { IKeyValue } from "../../../../components/Administrations/types";
import { useStoreDispatch } from "../../../../store/hooks";
import { setOpenToast } from "../../../../store/helpers/helperReducers";
import { setErrorMsg } from "../../../../store/helpers/helperReducers";
import { store } from "../../../../store";
import { dataPollerPayload, emailSmtpPayload, resetDataPoller, resetSmtpServer } from "../../../../components/helpers";
import { useGetDataPollersQuery, useGetEmailSmtpQuery, useSendTestEmailMutation, useUpdateDataPollersMutation, useUpdateSmtpEmailMutation } from "../../../../store/api/admin/adminApiSlice";
import { dataPollingPropsSelector, selectedSmtpEmailSelector } from "../../../../store/api/admin/selectors";
import { useSelector } from "react-redux";
import { IDataPollProps, ISmtpEmail } from "../../../../store/api/admin/types";
import { setDataPolingProperties, setSelectedSmtpEmail } from "../../../../store/api/admin/reducers";
import { isValidEmail, isValidPassword } from "../../../../utils/validations";
import { errorMessage, handleBooleanStringValues } from "../../../../utils/helpers";
import { xsdPathStr } from "../../../../globals/constants";

export const useDataPollerForm = () => {
  const dispatch = useStoreDispatch();
  const [errMsg, setErrMsg] = useState<IKeyValue>({});
  const dataPollingDetails = useSelector(dataPollingPropsSelector);
  const [dataPolling, setDataPolling] = useState<IDataPollProps>(dataPollingDetails);

  const { data, refetch } = useGetDataPollersQuery();
  const { dataPollingProperties } = xsdPathStr;

  const [updateDataPollers] = useUpdateDataPollersMutation();

  useEffect(() => {
    if (data) {
      //handle dispatch to store data in smtpEmail state
      let obj = {
        privatekey: data[dataPollingProperties?.privatekey] || "",
        port: data[dataPollingProperties?.port] || "22",
        dbgEnable: handleBooleanStringValues(data[dataPollingProperties?.dbgEnable] || "false"),
        kpiEnable: handleBooleanStringValues(data[dataPollingProperties?.kpiEnable] || "false"),
        alarmEnable: handleBooleanStringValues(data[dataPollingProperties?.alarmEnable] || "false"),
        enable: handleBooleanStringValues(data[dataPollingProperties?.enable] || "false"),
        cmEnable: handleBooleanStringValues(data[dataPollingProperties?.cmEnable] || "false"),
        ebEnable: handleBooleanStringValues(data[dataPollingProperties?.ebEnable] || "false"),
        maxDays: data[dataPollingProperties?.maxDays] || "3",
        pubkey: data[dataPollingProperties?.pubkey] || "",
        host: data[dataPollingProperties?.host] || "",
      }
      dispatch(setDataPolingProperties(obj));
      setDataPolling(obj);
      console.log("DATA", data)
    }
  }, [data, dispatch, refetch]);

  // const onBlurHandler = (event: any) => {
  //   const { name, value } = event?.target;
  //   if (name === "enableSmtp" && !SmtpServerData?.useSmtpAuth) {
  //     setErrMsg({ [name]: `Please enable Snmpv1v2!!` });
  //   }
  //   if (name === "smtpPort") {
  //     if (!value) {
  //       setErrMsg({ [name]: `Port is required!!` });
  //     } else setErrMsg({ [name]: `` });
  //   }
  //   if(name === "smtpHost") {
  //     if (!value) {
  //       setErrMsg({ [name]: `smtpHost is required!!` });
  //     }
  //      else setErrMsg({ [name]: `` });
  //   }
  //   if (name === "fromEmail") {
  //     if (!isValidEmail(value)) {
  //       setErrMsg({ [name]: `Invalid Email` });
  //     } else setErrMsg({ [name]: `` });
  //   }
  //   if (name === "smtpUsername") {
  //     if (!value) {
  //       setErrMsg({ [name]: `Username is required!` });
  //     } else setErrMsg({ [name]: `` });
  //   }
  //   if (name === "smtpPassword") {
  //     if (!value) {
  //       setErrMsg({ [name]: `Password is required!` });
  //     } 
  //     else if(!isValidPassword(value)) {
  //       setErrMsg({ ...errMsg, smtpPassword: `Password is invalid. It must meet the specified criteria!` });
  //     }
  //      else setErrMsg({ [name]: `` });
  //   }
  //   if (name === "testEmail") {
  //     if (!isValidEmail(value)) {
  //       setErrMsg({ [name]: `Invalid Email` });
  //     } else setErrMsg({ [name]: `` });
  //   }
  // };

  const handleValidateSmtp = (testKey?: string) => {
    // let isValid: boolean = true;
    // if (SmtpServerData?.fromEmail) {
    //   if (!isValidEmail(SmtpServerData?.fromEmail)) {
    //     setErrMsg({ fromEmail: `Invalid Email` });
    //     isValid = false;
    //   }
    // }
    // // if (!SmtpServerData?.useSmtpAuth) {
    // //   setErrMsg({ enableSmtp: `Please enable smtpAuth` });
    // //   isValid = false;
    // // }
    // if (SmtpServerData?.useSmtpAuth) {
    //   const { smtpUsername, smtpPassword } = SmtpServerData;
    //   if (!smtpUsername) {
    //     setErrMsg({ ...errMsg, smtpUsername: `Username is required!.` });
    //     isValid = false;
    //   }
    //   if (smtpPassword) {
    //     if (!isValidPassword(smtpPassword)) {
    //       setErrMsg({ ...errMsg, smtpPassword: `Password is invalid. It must meet the specified criteria!` });
    //       isValid = false;
    //     }
    //   }
    //   if (!smtpPassword) {
    //     setErrMsg({ ...errMsg, smtpPassword: `Password is required!.` });
    //     isValid = false;
    //   }
    // }
    // if (!SmtpServerData?.smtpPort) {
    //   setErrMsg({ smtpPort: `Port is required!!` });
    //   isValid = false;
    // }
    // if (!SmtpServerData?.smtpHost) {
    //   setErrMsg({ smtpHost: `smtpHost is required!!` });
    //   isValid = false;
    // }

    // if (testKey === "test") {
    //   if (!isValidEmail(SmtpServerData?.testEmail)) {
    //     setErrMsg({ testEmail: `Invalid Email` });
    //     isValid = false;
    //   }
    // }
    // return isValid;
  };

  const handleResetDataPollers = () => {
      setDataPolling({ ...resetDataPoller });
      dispatch(setErrorMsg({}));
    };


  const submitHandler = async () => {
    const storeErrors = store.getState().helpers.errorMsg;
    const hasErrors = Object.values(storeErrors).some((err) => err !== "");
    if (hasErrors) return;
      try {
        let result: any;
        result = await updateDataPollers(dataPollerPayload(dataPolling));
        if (result?.error) throw result?.error;
        if (result.data?.status === 200) {
          dispatch(
            setOpenToast({
              openToast: true,
              toastType: "success",
              message: "The data has been updated for Email Smtp",
            })
          );
          refetch();
        }
      } catch (error: any) {
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
      }
    // }
  };

  return {
    errMsg,
    setErrMsg,
    dataPolling, 
    setDataPolling,
    // onBlurHandler,
    handleResetDataPollers,
    submitHandler,
  };
};
